import "./styles.scss"

import React from "react"

import { useLocale } from "context/locale"

const UploadIndicator = ({ progress, estimated }) => {
  const { t } = useLocale()

  return (
    <div className="upload-indicator">
      <div className="upload-indicator__header">
        <p>{t("Please wait. Message is beign sent.")}</p>
        <p>
          {t("Estimated")}:{" "}
          {estimated ? getStringTime(Math.ceil(estimated)) : "unknown"}
        </p>
      </div>
      {progress && (
        <div className="upload-indicator__progress">
          <div className="upload-indicator__bar">
            <div
              className="upload-indicator__bar-inner"
              style={{ width: `${progress * 100}%` }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

const getStringTime = totalSeconds => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return minutes > 0
    ? `${minutes}min ${padNumber(seconds)}s`
    : `${padNumber(seconds)}s`
}

const padNumber = number =>
  number < 10 ? String(number).padStart(2, 0) : String(number)

export default UploadIndicator
